import { Box, Card, CardContent, Typography, Skeleton } from '@mui/material';

interface FeedbackMetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  loading?: boolean;
  icon?: React.ReactNode;
  format?: 'number' | 'percentage' | 'currency' | string;
}

export function FeedbackMetricCard({
  title,
  value,
  subtitle,
  loading = false,
  icon,
  format,
}: FeedbackMetricCardProps) {
  const formatValue = (val: string | number): string => {
    if (typeof val === 'string') return val;

    switch (format) {
      case 'percentage':
        return `${val.toFixed(1)}%`;
      case 'currency':
        return `$${val.toLocaleString()}`;
      case 'number':
      default:
        return val.toLocaleString();
    }
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          {icon && (
            <Box sx={{ color: 'primary.main', display: 'flex' }}>{icon}</Box>
          )}
          <Typography variant="subtitle2" color="text.secondary">
            {title}
          </Typography>
        </Box>
        {loading ? (
          <Skeleton  sx={{ width: 80, height: 40 }}/>
        ) : (
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {formatValue(value)}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
